import {
	ApiOutlined,
	FileAddOutlined,
	FileExcelOutlined,
	ThunderboltOutlined,
} from '@ant-design/icons';
import React from 'react';
import { Typography } from 'antd';
import { AICampaignFormData } from '../types';

interface LeadImportOption {
	id: string;
	title: string;
	description: string;
	icon: React.ReactNode;
}

interface StepFourProps {
	formData: AICampaignFormData;
	handleRadioChange: (name: keyof AICampaignFormData, value: string) => void;
}

const { Title } = Typography;

const StepFour: React.FC<StepFourProps> = ({ formData, handleRadioChange }) => {
	// Lead import options
	const importOptions: LeadImportOption[] = [
		{
			id: 'zapier',
			title: 'Zapier',
			description: 'Connect with 3,000+ apps to automatically add leads from your existing tools.',
			icon: (
				<div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
					<ThunderboltOutlined className="text-2xl text-purple-600" />
				</div>
			),
		},
		{
			id: 'api',
			title: 'API',
			description: 'Use our API to programmatically add leads from your own systems.',
			icon: (
				<div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
					<ApiOutlined className="text-2xl text-green-600" />
				</div>
			),
		},
		{
			id: 'manual',
			title: 'Manual Entry',
			description: 'Add leads one by one through our simple interface.',
			icon: (
				<div className="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center">
					<FileAddOutlined className="text-2xl text-orange-600" />
				</div>
			),
		},
		{
			id: 'csv',
			title: 'CSV Upload',
			description: 'Upload a spreadsheet with your lead data.',
			icon: (
				<div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
					<FileExcelOutlined className="text-2xl text-blue-600" />
				</div>
			),
		},
	];

	return (
		<div className="step-content">
			<Title>How will you be adding leads to the platform?</Title>
			<p className="text-gray-600 mb-6">
				Choose how you want to import your lead data. You can change this method later.
			</p>

			<div className="space-y-4">
				{importOptions.map((option) => (
					<label
						key={option.id}
						className={`block p-4 border rounded-lg cursor-pointer transition-colors ${
							formData.leadSourceType === option.id
								? 'border-blue-500 bg-blue-50'
								: 'border-gray-300 hover:border-gray-400'
						}`}
					>
						<div className="flex items-center">
							<input
								type="radio"
								name="importMethod"
								value={option.id}
								checked={formData.leadSourceType === option.id}
								onChange={() => handleRadioChange('leadSourceType', option.id)}
								className="hidden"
								required
							/>
							<div className="mr-4">{option.icon}</div>
							<div className="flex-1">
								<div className="font-medium">{option.title}</div>
								<div className="text-sm text-gray-500">{option.description}</div>
							</div>
						</div>
					</label>
				))}
			</div>
		</div>
	);
};

export default StepFour;
